/* eslint-disable */
import app from './app';
import rely from './oauth2rely';

/**
 * 检查字符串是否为undefined 或 长度为 0
 * @param variable
 * @returns {boolean}
 */
function isEmptyString(variable: any) {
    if (isUndefined(variable)) return true;
    return variable.length == 0;
}

function getRandomCode(n: number) {
    const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    let res = '';
    for (let i = 0; i < n; i++) {
        const id = Math.ceil(Math.random() * 35);
        res += chars[id];
    }
    return res;
}

/**
 * 获取API请求头
 * @param apiPath
 * @param method
 * @param opts
 * @param apiRoot
 * @returns {url: string, method: string, headers: any}
 */
function getApiFetchOptions(apiPath: string, method = 'GET', opts: any = {}, apiRoot = null) {
    const headers = opts.headers || {};

    const apiRootPath = isEmptyString(apiRoot) ? `${app.params.apiDomain}/${app.params.apiVersion}` : apiRoot;
    if (rely.__DEV__) {
        apiPath = apiPath.indexOf('?') == -1 ? `${apiPath}?XDEBUG_SESSION_START=PHPSTORM` : `${apiPath}&XDEBUG_SESSION_START=PHPSTORM`;
    }
    if (method == 'GET') apiPath = apiPath.indexOf('?') == -1 ? `${apiPath}?__rnd=${getRandomCode(4)}` : `${apiPath}&__rnd=${getRandomCode(4)}`;
    const endpoint = `${apiRootPath}/${apiPath}`;

    return {
        ...opts,
        url: endpoint,
        method: method,
        timeout: 1000,
        //credentials: __DEV__ ? 'include' : 'same-origin', //cookie，开发环境下，因为需要跨域，所以使用include
        headers: {
            ...headers,
            Accept: 'application/json',
            'Content-Type': headers['Content-Type'] || 'application/json',
        },
    };
}

/**
 * 检查参数是否为undefined 或者 null
 * @param variable
 * @returns {boolean}
 */
function isUndefined(variable: any) {
    if (variable === undefined) return true;
    if (variable == null) return true;
    return false;
}

/**
 * 获取当前的Host
 * @returns {string}
 */
function host() {
    const { protocol, host } = window.location;
    return protocol + '//' + host + '/';
}

/**
 * 过滤XSS
 * @param  {String}    str 需要过滤的内容
 * @return {String}    显示的内容
 */
function xss(str: string) {
    let div: any = document.createElement('div'),
        text: any = document.createTextNode(str),
        val = '';

    div.appendChild(text);
    val = div.innerHTML;
    text = null;
    div = null;

    return val.replace(/&amp;nbsp;/gi, ' ');
}
/**
 * 过滤><,&
 * @param  {String}    str 需要过滤的内容
 * @return {String}    显示的内容
 */
function escape2Html(str: string) {
    // var arrEntities={'lt':'<','gt':'>','nbsp':' ','amp':'&','quot':'"'};
    str = str.replace(/&lt;/gi, '<');
    str = str.replace(/&gt;/gi, '>');
    str = str.replace(/&nbsp;/gi, ' ');
    str = str.replace(/&amp;/gi, '&');
    str = str.replace(/&quot;/gi, '"');
    return str;
}
/**
 * 获取url或者自定义字符串中的参数
 *
 * @param {String} name 不传name则直接返回整个参数对象
 * @param {String} queryStr 自定义字符串
 * @param {Boolean} true 不进行参数XSS安全过滤
 * @param {Boolean} true 不进行自动解码
 * @return {String|Object} 获取到的参数值或者由所有参数组成完整对象
 */
function getQuery(name: string, queryStr = null, unxss = false, undecode = false) {
    let str = queryStr || location.search.replace('?', ''),
        tempArr,
        obj: any = {},
        temp,
        arr = str.split('&'),
        len = arr.length;

    if (len > 0) {
        for (let i = 0; i < len; i++) {
            try {
                if ((tempArr = arr[i].split('=')).length === 2) {
                    temp = undecode ? tempArr[1] : decodeURIComponent(tempArr[1]);
                    obj[tempArr[0]] = unxss ? temp : xss(temp);
                }
            } catch (e) {}
        }
    }

    return name ? obj[name] : obj;
}

function formatDate(date: Date, format: string) {
    const dateParams: any = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S+': date.getMilliseconds(),
    };
    if (/(y+)/i.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (const k in dateParams) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? dateParams[k] : ('00' + dateParams[k]).substr(('' + dateParams[k]).length));
        }
    }
    return format;
}

/**
 * 将时间转换成对应的格式 yyyy-MM-dd hh:mm:ss
 * @param  {string} format 需要转化的格式
 * @param  {object} date   需要转换的时间
 * @return {string}        按照对应格式转换后的时间
 */
function dateToString(date: Date, format: string) {
    date = date || new Date();
    return formatDate(date, format);
}

/**
 * 将string转换成时间
 * @param  {string} date    需要转成的字符串
 * @param  {string} split   默认为 '-'，如果显示为‘/’可不传
 * @return {object}         返回时间对象 or 返回本身
 */
function stringToDate(date: any, split: string) {
    if (typeof date == 'string') {
        // 匹配 2017-04-10T07:41:24.944Z GMT 时间，不做处理，直接进行转换
        let test: any = /([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8])))[ T](([01][0-9]|2[0-4]):([0-5][0-9]):([0-5][0-9])).([0-9][0-9][0-9][zZ])/gi.exec(date);
        if (!isUndefined(test) && test.length > 0) return new Date(date);
        // 匹配可能的时间格式 2017-04-10 2017/04/10 处理手工拼接的日期字符串
        test = /([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})[-/](((0[13578]|1[02])[-/](0[1-9]|[12][0-9]|3[01]))|((0[469]|11)[-/](0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8])))[ T](([01][0-9]|2[0-4]):([0-5][0-9]):([0-5][0-9]))/gi.exec(date);
        if (!isUndefined(test) && test.length > 0) {
            split = split || '-';
            return new Date(test[0].replace(new RegExp(split, 'gm'), '/').replace(new RegExp('T', 'gm'), ' '));
        }
    }
    return date;
}

function getDateDiff(dateTimeStamp: number) {
    const minute = 1000 * 60;
    const hour = minute * 60;
    const day = hour * 24;
    const halfamonth = day * 15;
    const month = day * 30;
    const now = new Date().getTime();
    const diffValue = now - dateTimeStamp;
    if (diffValue < 0) {
        return;
    }
    const monthC = diffValue / month;
    const weekC = diffValue / (7 * day);
    const dayC = diffValue / day;
    const hourC = diffValue / hour;
    const minC = diffValue / minute;
    let result = '';
    if (monthC >= 1) {
        result = '' + parseInt(monthC.toString()) + '月前';
    } else if (weekC >= 1) {
        result = '' + parseInt(weekC.toString()) + '周前';
    } else if (dayC >= 1) {
        result = '' + parseInt(dayC.toString()) + '天前';
    } else if (hourC >= 1) {
        result = '' + parseInt(hourC.toString()) + '小时前';
    } else if (minC >= 1) {
        result = '' + parseInt(minC.toString()) + '分钟前';
    } else result = '刚刚';
    return result;
}

// region 读写cookie
function getCookie(name: string) {
    let arr;
    const reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if ((arr = document.cookie.match(reg))) return decodeURIComponent(arr[2]);
    else return undefined;
}
function removeCookie(name: string) {
    const exp: any = new Date();
    exp.setTime(exp.getTime() - 1);
    const value: any = getCookie(name);
    if (!isUndefined(value)) document.cookie = `${name}=${encodeURIComponent(value)}expires=${exp.toGMTString()}`;
}
function setCookie(name: string, value: string, expiredInSecond = 0, domain = '') {
    let cookie = `${name}=${encodeURIComponent(value)};path=/`;
    if (expiredInSecond > 0) {
        const exp: any = new Date();
        exp.setTime(exp.getTime() + expiredInSecond * 1000);
        cookie = `${cookie};expires=${exp.toGMTString()}`;
    }
    if (!isEmptyString(domain)) {
        cookie = `${cookie};domain=${domain}`;
    }
    document.cookie = cookie;
}
// endregion

// region deep assign
// endregion

function bytesToSize(bytes: number) {
    if (bytes === 0) return '0 B';
    const k = 1024, // or 1024
        sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        i = Math.floor(Math.log(bytes) / Math.log(k));

    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
}

/**
 * 将列表数据转换成树形数据（支持多顶层节点，如果出现断层，则会导致树形中断），非递归实现，不存在内存栈溢出
 * @param sourceList 原始列表数据
 * @param uidKey 自身唯一标识
 * @param parentKey 父级键名
 * @param childrenKey 用于存放子级的键名
 * @returns Array<any>
 */
function list2Tree(sourceList: any, uidKey: any, parentKey: any, childrenKey: any) {
    const uidMap: any = {};
    const treeResult: any = [];
    sourceList.map((item: { [x: string]: string | number }) => {
        uidMap[item[uidKey]] = item;
    });
    sourceList.map((item: { [x: string]: string | number }) => {
        const parentNode = uidMap[item[parentKey]];
        if (!isUndefined(parentNode)) {
            if (childrenKey in parentNode) {
                parentNode[childrenKey].push(item);
            } else {
                parentNode[childrenKey] = [];
                parentNode[childrenKey].push(item);
            }
        } else {
            // 顶层节点
            treeResult.push(item);
        }
    });
    return treeResult;
}
function tree2List(sourceList: any[], childrenKey: string | number) {
    let listResult: any[] = [];
    sourceList.map((item: { [x: string]: any }) => {
        let cloneItem;
        try {
            cloneItem = JSON.parse(JSON.stringify(item));
            delete cloneItem[childrenKey];
        } catch (e) {
            cloneItem = Object.create(null);
        }
        listResult.push(cloneItem);
        if (!(isUndefined(item[childrenKey]) || !Array.isArray(item[childrenKey]) || item[childrenKey].length === 0)) {
            listResult = Array.prototype.concat.apply(listResult, tree2List(item[childrenKey], childrenKey));
        }
    });
    return listResult;
}
async function filterTree(treeList: any, childrenKey: any, filterFunc: { call: (arg0: any, arg1: any) => unknown }, caller: any) {
    const simpleList = tree2List(treeList, childrenKey);
    const allMatchNodeArr = simpleList.filter(item => {
        return filterFunc.call(caller, item);
    });
    if (allMatchNodeArr.length == 0) {
        return Promise.resolve([]);
    } else {
        const allNodes: any[] = [];
        for (let i = 0; i < allMatchNodeArr.length; i++) {
            const relativeNodes = _findAllParentAndSelf(allMatchNodeArr[i], simpleList);
            relativeNodes.map(item => {
                if (!_isContain(allNodes, item)) {
                    allNodes.push(item);
                }
            });
        }
        const tempList = allNodes.map(item => {
            const OrgCodeArray = item.OrderCode.split('.');
            if (OrgCodeArray.length == 1) {
                return {
                    ...item,
                    parent: null,
                };
            } else {
                return {
                    ...item,
                    parent: OrgCodeArray.slice(0, OrgCodeArray.length - 1).join('.'),
                };
            }
        });
        return Promise.resolve(list2Tree(allNodes, 'OrderCode', 'parent', 'children'));
    }
}
function _findAllParentAndSelf(node: any, list: any[]) {
    const parentNodes = [];
    let parent = node;
    while (parent != undefined) {
        parentNodes.push(parent);
        parent = _findParent(parent, list);
    }
    return parentNodes;
}
function _findParent(node: { OrderCode: string }, list: any[]) {
    const _codeArr: any = node.OrderCode.split('.');
    if (_codeArr < 2) {
        return;
    }

    const mnode = list.find((item: { OrderCode: any }) => {
        return item.OrderCode == _codeArr.slice(0, _codeArr.length - 1).join('.');
    });
    return mnode;
}
function _isContain(list: string | any[], node: any) {
    return list.indexOf(node) > -1;
}
const math = {
    addition(arg1: number, arg2: number) {
        if (isNaN(arg1) || isNaN(arg2) || arg1 == Infinity || arg1 == -Infinity || arg2 == Infinity || arg2 == -Infinity) {
            return 0;
        }
        let r1;
        let r2;
        let m;
        try {
            r1 = arg1.toString().split('.')[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split('.')[1].length;
        } catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        return this.division(this.multiplication(arg1, m) + this.multiplication(arg2, m), m);
    },
    subtraction(arg1: any, arg2: number) {
        return this.addition(arg1, -arg2);
    },
    multiplication(arg1: number, arg2: number) {
        if (isNaN(arg1) || isNaN(arg2) || arg1 == Infinity || arg1 == -Infinity || arg2 == Infinity || arg2 == -Infinity) {
            return 0;
        }
        let m = 0;
        const s1 = arg1.toString();
        const s2 = arg2.toString();
        try {
            m += s1.split('.')[1].length;
            // tslint:disable-next-line:no-empty
        } catch (e) {}
        try {
            m += s2.split('.')[1].length;
            // tslint:disable-next-line:no-empty
        } catch (e) {}
        return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m);
    },
    division(arg1: number, arg2: number) {
        if (isNaN(arg1) || isNaN(arg2) || arg1 == Infinity || arg1 == -Infinity || arg2 == Infinity || arg2 == -Infinity) {
            return 0;
        }
        if (arg2 === 0) {
            console.error('[MathError]:被除数不能为0');
            return 0;
        }
        let t1 = 0;
        let t2 = 0;
        let r1;
        let r2;
        try {
            t1 = arg1.toString().split('.')[1].length;
            // tslint:disable-next-line:no-empty
        } catch (e) {}
        try {
            t2 = arg2.toString().split('.')[1].length;
            // tslint:disable-next-line:no-empty
        } catch (e) {}
        // @ts-ignore
        r1 = Number(arg1.toString().replace('.', ''));
        r2 = Number(arg2.toString().replace('.', ''));
        return (r1 / r2) * Math.pow(10, t2 - t1);
    },
};
export { isUndefined, isEmptyString, host, xss, getQuery, dateToString, stringToDate, getApiFetchOptions, getDateDiff, getRandomCode, getCookie, removeCookie, setCookie, bytesToSize, escape2Html, list2Tree, tree2List, filterTree, math };
